// extracted by mini-css-extract-plugin
export var aggregationCell = "_2h-h";
export var aggregationRow = "_2h-g";
export var borderlessSpinnerContainer = "_2h-2";
export var closeIcon = "_2h-9";
export var expandIcon = "_2h-a";
export var expanded = "_2h-b";
export var filterDropdown = "_2h-c";
export var filterDropdownDivider = "_2h-7";
export var filterDropdownHeader = "_2h-f";
export var filterDropdownItem = "_2h-e";
export var filterDropdownModal = "_2h-d _2h-c";
export var filterItem = "_2h-6";
export var normalCellWithAdjustableBorder = "_2h-8";
export var pinButtonContainer = "_2h-i";
export var pinIcon = "_2h-j";
export var pinIconActive = "_2h-k";
export var spinner = "_2h-0";
export var spinnerContainer = "_2h-1";
export var tableContainer = "_2h-3";
export var tableContentInner = "_2h-5";
export var tableContentWrapper = "_2h-4";
export var viewButtonContainer = "_2h-l";